/* Collection title enter, matched to the Framer appear on the panel name:
   from opacity 0, y 50, scale 1.6
   to opacity 0.8, y 0, scale 1
   spring duration 1.2s, delay 0.5s. Plays again each time the panel enters. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (!root || root.dataset.wbsHeroProductReady === 'true') return;
    root.dataset.wbsHeroProductReady = 'true';

    var panels = root.querySelectorAll('.wbs-hero-product__panel');
    if (!panels.length) return;

    if (reduce.matches || !('IntersectionObserver' in window)) {
      panels.forEach(function (panel) {
        panel.classList.add('is-wbs-in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-wbs-in', entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );

    panels.forEach(function (panel) {
      observer.observe(panel);
    });
  }

  function boot() {
    document.querySelectorAll('.wbs-hero-product').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.wbs-hero-product');
    if (root) init(root);
  });
})();
